import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ModalComponent } from '../../modal/modal.component';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { UpgradesPluginService } from './upgrades-plugin.service';
import * as _ from 'lodash';
import { map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UpgradesMenuComponent } from '../../menus';

@Component({
    selector: 'upgrades-edit',
    templateUrl: './upgrades-edit.component.html',
    standalone: false
})
export class UpgradesEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pluginId: string;
  plugin: any;
  processing = false;
  upgrades: any[];
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;

  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  public menuComponent = UpgradesMenuComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: UpgradesPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save() {
    this.processing = true;
    this.service.updateUpgrades(this.inspectionId, this.pluginId, this.upgrades).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.upgrades = this.plugin.config.Upgrades ?? [];
      if (!this.upgrades.length) {
        this.processing = true;
        this.loadData()
          .pipe(
            switchMap((upgrades) => {
              this.upgrades = upgrades;
              if (this.upgrades?.length) {
                return this.service.updateUpgrades(this.inspectionId, this.pluginId, this.upgrades, {
                  ignoreLoader: 'true'
                });
              }
              return of(null);
            })
          )
          .subscribe(() => {
            this.processing = false;
            this.cdRef.detectChanges();
          });
      }
      this.cdRef.detectChanges();
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      case 20:
        this.reloadData();
        break;
      default:
    }
  }

  reloadData() {
    this.upgrades = [];
    this.processing = true;
    this.loadData().subscribe((obsolescences) => {
      this.upgrades = obsolescences;
      this.processing = false;
      this.cdRef.detectChanges();
    });
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, null, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  update(upgrade: any) {
    if (upgrade.Status === 'already-installed') return;
    upgrade.Recommended = !upgrade.Recommended;
  }

  private loadData() {
    return this.service
      .getUpgrades(this.inspectionId, { ignoreLoader: 'true' })
      .pipe(map((upgrades) => upgrades.map((u) => ({ ...u, Data: JSON.stringify(u) }))));
  }
}
